import { RootState } from "@src/store";

export const selectSelectedHistoryOrder = (state: RootState) =>
  (state as any).history.selectedOrder;
